app.views.accountSelector = app.views.base.extend({
  init: function init() {
    this.initSpinners();
    this.initEventListeners();
  },
  initEventListeners: function initEventListeners() {
    var _this = this;
    $('[data-selected-account]').on('change', function () {
      _this.onAccountSelect();
    });
  },
  onAccountSelect: function onAccountSelect() {
    $('[data-next]').prop('disabled', false);
  },
  initSpinners: function initSpinners() {
    var _this = this;
    var containerId = 'account-selector';
    $('#' + containerId).find('.btn, .btn-action, a').each(function (i) {
      $(this).on('click', function () {
        var spinner = $('#' + containerId).find('.form-spinner');
        if (spinner) {
          spinner.show();
        }
      });
    });
  }
});